import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UsersModel } from 'common/models/page-models/users/user-data-model';
import { UsersListingModel } from 'common/models/page-models/users/users-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { UsersGridWidgetService } from 'common/widget/users/users-grid-widget.service';

 
@Injectable({
    providedIn: 'root'
})
export class UsersGridResolver extends GridResolver<UsersModel, UsersListingModel> {
    constructor(
        protected fs: UsersGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}